// Room oversight (Räume > Verwaltung, Nachrichten > Räume > Verwaltung): the
// companies whose rooms the viewer manages, and the /company/my rows they come
// from. Mirrors the mobile app's utils/roomOversight.js.
import { callAPI } from "../helper/apiUtils";

/**
 * Company admins only, the same rule as the cockpit's room admin card (mobile
 * viewerManagesCompanyRooms). ROLE_COMPANY_ADMIN is an ordinary employee and
 * ROLE_COMPANY_DEPARTMENT_ADMIN a department admin; neither reaches this.
 * Accepts /company/my rows (role, position) and cockpit entries (myRole, myPosition).
 */
export function managesCompanyRooms(company) {
  if (!company || company.id == null) return false;
  const role = company.myRole || company.role;
  const position = company.myPosition || company.position;
  if (company.isSuperAdmin || role === "ROLE_COMPANY_SUPER_ADMIN") return true;
  return String(position || "").trim().toLowerCase() === "company admin";
}

// Last /company/my answer, kept across visits so oversight entries show at once
// instead of after a refetch. Keyed by login token so it never carries over to
// another account.
let myCompanies = { token: null, list: [] };

/** The cached /company/my rows for this login, or [] before the first answer. */
export function cachedMyCompanies(token) {
  return myCompanies.token && myCompanies.token === token ? myCompanies.list : [];
}

/** GET /company/my → the rows (also cached), or null when the call fails. */
export async function fetchMyCompanies(token) {
  const { data } = await callAPI(`/company/my`, {}, "GET");
  if (data && data.status) {
    myCompanies = { token, list: data.companies || [] };
    return myCompanies.list;
  }
  return null;
}

/**
 * The company an oversight list starts on: the preferred ids in order (the
 * last pick, the app-wide company) when the viewer manages them, else the first.
 */
export function pickOversightCompany(companies, ...preferred) {
  const list = Array.isArray(companies) ? companies : [];
  for (const id of preferred) {
    if (id == null) continue;
    const hit = list.find((c) => String(c.id) === String(id));
    if (hit) return hit;
  }
  return list[0] || null;
}
